import { Type } from "@sinclair/typebox";
import { IdSchema, NonNegativeIntegerSchema, Sha256Schema } from "./shared.js";
export const ProviderSearchEvidenceModeSchema = Type.Union([
    Type.Literal("structured_sources"),
    Type.Literal("summary_only"),
]);
export const ProviderSearchSourceSchema = Type.Object({
    sourceId: IdSchema,
    title: Type.String({ minLength: 1, maxLength: 1_024 }),
    url: Type.String({ minLength: 8, maxLength: 8_192 }),
    snippet: Type.Optional(Type.String({ maxLength: 8_192 })),
    publishedAt: Type.Optional(Type.String({ format: "date-time" })),
}, { additionalProperties: false });
export const ProviderSearchCitationSchema = Type.Object({ sourceId: IdSchema }, { additionalProperties: false });
const ProviderSearchResultBase = {
    kind: Type.Literal("web_search"),
    answer: Type.String({ minLength: 1, maxLength: 2_000_000 }),
    searchCallCount: Type.Integer({ minimum: 1, maximum: 64 }),
    upstreamRequestCount: Type.Integer({ minimum: 1, maximum: 128 }),
    truncated: Type.Boolean(),
};
export const ProviderSearchResultSchema = Type.Union([
    Type.Object({
        ...ProviderSearchResultBase,
        evidenceMode: Type.Literal("summary_only"),
        sources: Type.Array(ProviderSearchSourceSchema, { maxItems: 0 }),
        citations: Type.Array(ProviderSearchCitationSchema, { maxItems: 0 }),
    }, { additionalProperties: false }),
    Type.Object({
        ...ProviderSearchResultBase,
        evidenceMode: Type.Literal("structured_sources"),
        sources: Type.Array(ProviderSearchSourceSchema, { minItems: 1, maxItems: 50 }),
        citations: Type.Array(ProviderSearchCitationSchema, { minItems: 1, maxItems: 200 }),
    }, { additionalProperties: false }),
]);
export const ProviderSearchFailureSchema = Type.Object({
    kind: Type.Literal("web_search_failure"),
    code: Type.Union([
        Type.Literal("provider_search_not_dispatched"),
        Type.Literal("provider_search_dispatch_uncertain"),
        Type.Literal("provider_search_upstream_failed"),
        Type.Literal("provider_search_invalid_response"),
        Type.Literal("provider_search_cancelled"),
    ]),
}, { additionalProperties: false });
export const ProviderSearchCostSchema = Type.Object({
    cpuMillis: NonNegativeIntegerSchema,
    memoryBytes: NonNegativeIntegerSchema,
    inputBytes: NonNegativeIntegerSchema,
    outputBytes: NonNegativeIntegerSchema,
    externalCalls: NonNegativeIntegerSchema,
}, { additionalProperties: false });
export const ProviderSearchUsageSchema = Type.Union([
    Type.Object({ inputTokens: NonNegativeIntegerSchema, outputTokens: NonNegativeIntegerSchema }, { additionalProperties: false }),
    Type.Object({ inputTokens: Type.Null(), outputTokens: Type.Null() }, { additionalProperties: false }),
]);
export const ProviderSearchProxyRequestSchema = Type.Object({
    actionId: IdSchema,
    actionGrantId: IdSchema,
    actionRequestDigest: Sha256Schema,
    providerConfigDigest: Sha256Schema,
    query: Type.String({ minLength: 1, maxLength: 2_048 }),
    mode: Type.Union([Type.Literal("claim_or_observe"), Type.Literal("observe_only")]),
}, { additionalProperties: false });
export const ProviderSearchProxyResponseSchema = Type.Union([
    Type.Object({
        status: Type.Literal("succeeded"),
        result: ProviderSearchResultSchema,
        actualCost: ProviderSearchCostSchema,
        usage: ProviderSearchUsageSchema,
    }, { additionalProperties: false }),
    Type.Object({
        status: Type.Literal("failed"),
        result: ProviderSearchFailureSchema,
        actualCost: ProviderSearchCostSchema,
        usage: ProviderSearchUsageSchema,
    }, { additionalProperties: false }),
]);
export const ProviderSearchMessageBodySchema = Type.Union([
    Type.Object({ kind: Type.Literal("proxy_request"), value: ProviderSearchProxyRequestSchema }, { additionalProperties: false }),
    Type.Object({ kind: Type.Literal("proxy_response"), value: ProviderSearchProxyResponseSchema }, { additionalProperties: false }),
]);
//# sourceMappingURL=provider-search.js.map